export function sendResultsLoadedMessage() {
  if (window.parent && window.parentIFrame) {
    window.parent.postMessage("Results loaded", '*');
  } else {
    console.log('would trigger event in parent: Results loaded');
  }
}

export async function reviewsfetch(url, params) {
  const fetchGetJSON = {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  };

  for (const param in params) {
    if (Array.isArray(params[param])) {
      params[param].forEach(val => {
        url += `&${param}=${val}`;
      });
    } else {
      url += `&${param}=${params[param]}`;
    }
  }

  try {
    const response = await fetch(url, fetchGetJSON);
    const data = await response.json();
    return data;
  } catch(err) {
    return Promise.reject(err);
  }
}

export function createReviews(container, entityId) {
  const reviewsEl = container.querySelector('.js-reviews-summary');
  const starsEl = container.querySelector('.js-reviews-stars');
  const scoreEl = container.querySelector('.js-reviews-score');
  const countEl = container.querySelector('.js-reviews-count');
  const count = countEl?.innerHTML ? parseInt(countEl.innerHTML, 10) || null : null;
  const rating = scoreEl?.innerHTML ? parseFloat(scoreEl.innerHTML) || null : null;
  let starEmpty = document.createElement('div');
  starEmpty.setAttribute('class', 'star-empty');
  if (count > 0 && rating && reviewsEl && starsEl) {
    const remainder = rating % 1;
    const emptyStars = Math.floor(5 - rating);
    for (let i = 0; i < Math.floor(rating); i++) {
      this.appendStar(starsEl, 'full');
    }
    if (remainder > 0.75) {
      this.appendStar(starsEl, 'full');
    } else if (remainder > 0.25) {
      this.appendStar(starsEl, 'half');
    } else if (remainder > 0) {
      this.appendStar(starsEl, 'empty');
    }
    for (let i = 0; i < emptyStars; i++) {
      this.appendStar(starsEl, 'empty');
    }
    reviewsEl.setAttribute('data-rating', rating.toFixed(2));
    reviewsEl.setAttribute('data-count', count);
    countEl.innerHTML = '(' + count + ')';
  }

  return entityId;
}

export function injectReviews(id) {
  const reviewsContainer = document.getElementById("card-" + id);
  if (!reviewsContainer) return;
  this.createReviews(reviewsContainer, id);
}

export function appendStar(target, type) {
  let star = document.createElement('div');
  if (type == 'full') {
    star.setAttribute('class', 'star-filled');
  } else if (type == 'half') {
    star.setAttribute('class', 'star-half');
  } else if (type == 'empty') {
    star.setAttribute('class', 'star-empty');
  }

  target.appendChild(star);
}


// Sort results based on percent match then by review score
export function compareResults(a, b) {
  const percentA = parseInt(a.querySelector('.HitchhikerProductProminentImage-percentage')?.dataset?.percent || 0);
  const percentB = parseInt(b.querySelector('.HitchhikerProductProminentImage-percentage')?.dataset?.percent || 0);

  if (percentA !== percentB) return percentB - percentA;

  // If percent match is the same, sort by number of reviews
  const reviewsElA = a.querySelector('.js-reviews-summary');
  const reviewsElB = b.querySelector('.js-reviews-summary');
  const ratingCountA = reviewsElA?.dataset?.count ? parseFloat(reviewsElA.dataset.count) : 0;
  const ratingCountB = reviewsElB?.dataset?.count ? parseFloat(reviewsElB.dataset.count) : 0;

  if (ratingCountB !== ratingCountA) return ratingCountB - ratingCountA;

  // If number of reviews is also the same, sort by reviews score
  const ratingA = reviewsElA?.dataset?.rating ? parseFloat(reviewsElA.dataset.rating) : 0;
  const ratingB = reviewsElB?.dataset?.rating ? parseFloat(reviewsElB.dataset.rating) : 0;

  return ratingB - ratingA;
}
